<template>
  <el-container class="home-wrap">
    <el-main class="full-content buy-table">
      <div class="flex-row-end buy-header">
          <el-button class="otherBtn buy-footer-btn">{{$t('Delete all')}}</el-button>
          <el-button class="otherBtn buy-footer-btn" style="margin-right:20px">{{$t('Mark all as read')}}</el-button>
      </div>
      <div class="flex-col-center buy-main">
        <div><img :src="$Image('nodata.png')" alt=""></div>
        <div class="nodata-found">{{$t('No data found')}}</div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Notifications',
  props: ['userid', 'device'],
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.home-wrap{
  width:100%;
  height:90%;
  box-sizing: border-box;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 100%;
    .buy-header{
      width:100%;
      height:9%;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      color: #333333;
      font-size: 24px;
    }
    .buy-main{
      width: 100%;
      height: 75%;
      .nodata-found{
        font-size: 18px;font-weight: normal;line-height: 54px;color: #777777;margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue